import { push } from 'connected-react-router';
import { createAction } from 'redux-actions';

import RouterConstants from '@app/constants/router';
import { getPaymentParams } from '@app/helpers/payment';
import * as PaymentService from '@app/services/paymentService';

import {
  setSubscriptionPurchaseInProgress, checkSubscriptionValidity,
} from '@app/actions/subscribeActions';

export const failureAskProcessPayment = createAction('PAYMENT/FAILURE_ASK_PROCESS_PAYMENT');
export const setPaymentInProgress = createAction('PAYMENT/SET_PAYMENT_CONFIRM_IN_PROGRESS');
export const resetPayments = createAction('PAYMENT/RESET_PAYMENTS');
export const resetPaymentErrors = createAction('PAYMENT/RESET_PAYMENT_ERRORS');

export function processPayment() {
  return (dispatch, getState) => {
    const {
      user: { authToken },
      subscribe: { promoCode },
    } = getState();

    const params = getPaymentParams(promoCode);

    return PaymentService.askPayment(params, authToken)
      .then((transaction) => {
        window.location.href = transaction.action;
      })
      .catch((error) => {
        // 500 is case when Price = 0 (Full Discount promo code / Free Trial package)
        if (error.code !== -500) {
          console.error('Error on ask payment data', error);
          dispatch(failureAskProcessPayment(error));
        }

        dispatch(push(RouterConstants.PAYMENT_RESULT));
      });
  };
}

/**
 * Payment: check DataCash proceeded payment status
 * @return {Function}
 */
export function checkPaymentStatus() {
  return (dispatch, getState) => {
    dispatch(setSubscriptionPurchaseInProgress(true));

    let iCounter = 0;

    const interval = setInterval(() => dispatch(checkSubscriptionValidity())
      .finally(() => {
        const { subscribe: { isSubscriptionActive } } = getState();
        iCounter += 1;

        if (isSubscriptionActive || iCounter >= 3) {
          clearInterval(interval);
          dispatch(setSubscriptionPurchaseInProgress(false));
        }
      }), 2000);
  };
}
